import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

import { storeCredentials, validateCredentials, UnauthorizedError } from '../lib/api';

export function LoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await validateCredentials(username, password);
      storeCredentials(username, password);
      navigate('/');
    } catch (err) {
      setError(err instanceof UnauthorizedError ? 'Invalid credentials' : 'Could not reach the API');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-forest px-4">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-sm rounded-xl border border-stone-200 bg-white p-6 shadow-hero sm:p-7"
      >
        <div className="mb-6 flex flex-col items-center text-center">
          <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-lg bg-primary text-lg font-black text-white">
            R
          </div>
          <div className="text-base font-extrabold tracking-wider text-stone-900">RUTA</div>
          <div className="mt-0.5 text-[11px] uppercase tracking-wider text-stone-400">
            Admin Insights · Platform operators only
          </div>
        </div>
        <label className="mb-3 block">
          <span className="mb-1.5 block text-[11px] font-medium uppercase tracking-wider text-stone-400">
            Username
          </span>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            required
            className="w-full rounded-md border border-stone-300 px-3 py-2 text-sm outline-none transition-colors focus:border-primary focus:ring-1 focus:ring-primary"
          />
        </label>
        <label className="mb-4 block">
          <span className="mb-1.5 block text-[11px] font-medium uppercase tracking-wider text-stone-400">
            Password
          </span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
            className="w-full rounded-md border border-stone-300 px-3 py-2 text-sm outline-none transition-colors focus:border-primary focus:ring-1 focus:ring-primary"
          />
        </label>
        {error && <div className="mb-3 text-xs text-red-600">{error}</div>}
        <button
          type="submit"
          disabled={submitting}
          className="w-full rounded-md bg-primary px-3 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary-2 disabled:opacity-50"
        >
          {submitting ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
